module.exports = __webpack_public_path__ + "static/media/4-14.d1f5cced.png";